import toast, { ToastOptions } from 'react-hot-toast';
import i18n from 'App/i18n';

export interface ToastParams {
  title: string;
  message?: string;
  duration?: number;
}

const defaultOptions: ToastOptions = {
  position: 'top-right',
  duration: 5000,
};

const formatMessage = (title: string, message?: string): string => {
  const translatedTitle = i18n.t(title);
  if (message) {
    const translatedMessage = i18n.t(message);
    return `${translatedTitle}\n${translatedMessage}`;
  }
  return translatedTitle;
};

export const toastService = {
  success: ({ title, message, duration = 5000 }: ToastParams) => {
    toast.success(formatMessage(title, message), {
      ...defaultOptions,
      duration,
    });
  },

  error: ({ title, message, duration = 5000 }: ToastParams) => {
    toast.error(formatMessage(title, message), {
      ...defaultOptions,
      duration,
    });
  },

  info: ({ title, message, duration = 5000 }: ToastParams) => {
    toast(formatMessage(title, message), {
      ...defaultOptions,
      duration,
      icon: 'ℹ️',
    });
  },

  dismiss: (toastId?: string) => {
    if (toastId) {
      toast.dismiss(toastId);
    } else {
      toast.dismiss();
    }
  },
};

export default toastService;
